/**
 * @generated SignedSource<<d90f5e0c653e19071d1cd823e82440a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku" | "PdpSharedBlurbLeadTime_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isSiderailRedesignVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbShipping_sku"
        }
      ]
    },
    {
      "condition": "isSiderailRedesignVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbLeadTime_sku"
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "d82e19bf6c995bc3d461dcfa641efd12";

export default node;
